module.exports = __webpack_public_path__ + "img/plug-in-background.821b206b.jpg";